import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getAwailableReports = async () => {
  return await request.get(
    `/HousingStock/report/awailable`,
    {},
    'При загрузке информации о доступных отчетах произошла ошибка',
    []
  );
};

const useAwailableReports = (options = {}) =>
  useQuery(
    getQueryKeys.awailableReports(),
    () => getAwailableReports(),
    options
  );

export default useAwailableReports;
